var DurationPipe = (function () {
    function DurationPipe() {
    }
    DurationPipe.prototype.transform = function (value) {
        var minutes = Math.floor(value / 60);
        var seconds = Math.floor(value - 60 * minutes);
        var secondsString = seconds < 10 ? '0' + seconds : seconds;
        var countDown = secondsString;
        return minutes + ":" + secondsString;
    };
    return DurationPipe;
}());
export { DurationPipe };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/video-player/duration.pipe.ts.pre-build-optimizer.js